export default __webpack_public_path__ + "static/media/STRYKER 125_1.6b1aec9b.webp";